import React, {Component, PropTypes, cloneElement} from 'react';
import {Col, Row, Input, Label, Button, FormGroup, Container, ModalFooter} from 'src/components/Common/reactstrap/lib';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import styles from 'src/components/Catalog/Catalog.scss';
import * as actions from '../redux/userAction';
import carImg from 'src/imgs/car/default-car.jpg';
import { browserHistory } from 'react-router';

export class GarageSaveCar extends Component {
  constructor(props) {
    super(props);
    let {VIN, Mileage} = (props.car)? props.car : 0;
    this.state = {
      VIN,
      Mileage
    };

    this.submit = this.submit.bind(this);
    this.inputVIN = this.inputVIN.bind(this);
    this.inputMileage = this.inputMileage.bind(this);
  }
  submit = () => {

    const {Brand, Model, GarageId} = this.props.car ? this.props.car : this.props;
    const {VIN, Mileage} = this.state;
    const modificationId = this.props.params ? this.props.params.modificationId : 0;
    this.props.updateUserGarage([
      {
        GarageId: GarageId || 0,
        Modification: { ModificationId: modificationId},
        VIN: VIN,
        Mileage: Mileage
      }]);

    if(modificationId != 0)
      browserHistory.replace({pathname: '/garage', query: { status: 'done'}});
    else
      this.props.startModal();
  };
  inputVIN(e) {
    this.setState({
      VIN: e.target.value
    });
  }
  inputMileage(e) {
    this.setState({
      Mileage: e.target.value
    });
  }
  render() {
// different name of variables from API
    let imgUrl  = (this.props.car) ? this.props.car.Model.ImgUrl : this.props.model.imgUrl,
      brandName  = (this.props.car) ? this.props.car.Brand.BrandName : this.props.brand.brandName,
      modelName = (this.props.car) ? this.props.car.Model.ModelName : this.props.model.modelName,
      modelYearStart = (this.props.car) ? this.props.car.Model.ModelYearStart : this.props.model.modelYearStart,
      modelYearEnd = (this.props.car) ? this.props.car.Model.ModelYearEnd : this.props.model.modelYearEnd;

    return (

        <div className={styles.Catalog}>
          <div className={styles.back_link}>
            <i className={styles.leftArrow}>&larr; </i>
            <button className="btn btn-link" onClick={() => window.history.back()}>Вернуться назад</button>
          </div>

          <div className={styles.model_container}>
            <img className={styles.responsive_img} src={imgUrl}
                 onError={(e) => e.target.src = carImg}/>
            <div className={styles.car_info}>
              <span><a href="#" className="link">{brandName} {modelName}</a></span>
              <h5
                className={styles.car_year}>{modelYearStart + ' - '}{modelYearEnd ? (modelYearEnd) : 'наст. время'}</h5>
            </div>
          </div>
        <Row>
        <Col sm={4}>
        <FormGroup row className="no-gutters">

            <Label sm={2}>пробег </Label>
            <Col sm={4}>
              <Input type="number" onChange={this.inputMileage} value={this.state.Mileage}/>
            </Col>
          <Label sm={{size: 2, pull: 3, offset: 3}}>км</Label>
            <Label sm={2}>VIN</Label>
            <Col sm={8}>
              <Input type="text" onChange={this.inputVIN} value={this.state.VIN}/>
            </Col>
        </FormGroup>
        </Col>
        </Row>
        <Row>
          <Col sm={{size: 3, pull: 9, offset: 9}}>
            <Button className="btn-wide" onClick={this.submit}>Сохранить</Button>
          </Col>
        </Row>
        </div>
    );
  }
}

export default connect(
  (state) => ({...state.catalogReducer}),
  (dispatch) => ({...bindActionCreators(actions, dispatch)})
)(GarageSaveCar);



/** WEBPACK FOOTER **
 ** ./src/components/User/elements/GarageSaveCar.jsx
 **/